const TOWNS = [
  "West Chester",
  "Kennett Square",
  "Downingtown",
  "Coatesville",
  "Exton",
  "Oxford",
  "Malvern",
  "Phoenixville",
];

const Marquee = () => {
  const items = [...TOWNS, ...TOWNS];
  return (
    <div
      data-testid="towns-marquee"
      className="bg-[#f2ece1] border-y border-[#e7e1d6] py-4 overflow-hidden"
      aria-label="Proudly serving Chester County towns"
    >
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center shrink-0">
            {items.map((town, i) => (
              <span
                key={`${half}-${i}`}
                className="flex items-center text-sm font-sans font-semibold tracking-[0.2em] uppercase text-[#a37d3f] whitespace-nowrap"
              >
                <span className="px-6">{town}</span>
                <span className="text-[#c99a43]">&#10022;</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
